import axiosInstance from "../utils/axios"

export const rewardService = {
  fetchAllWithoutPaginate: async (params = {}) => {
    const response = await axiosInstance.get('/reward', {
      params,
    })
    return response.data
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/reward/paginate', {
      params,
    })
    return response.data
  },
  getById: async (id) => {
    const response = await axiosInstance.get('/reward/' + id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/reward', data)
    return response.data
  },
  update: async (data) => {
    const response = await axiosInstance.put(`/reward/${data.id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/reward/${id}`)
    return response.data
  },
}